<template>
  <el-form :inline="true" :model="queryParam" class="mainSearch">
    <el-form-item label="名称">
      <el-input v-model="queryParam.name" placeholder="组名称" />
    </el-form-item>

    <el-form-item>
      <el-button type="danger" @click="getListGroup">查询</el-button>
      <el-button @click="resetSearch">重置</el-button>
    </el-form-item>
  </el-form>
  <el-row>
    <el-col :span="24">
      <div style="background: #fff; padding: 20px 20px 0; text-align: right">
        <el-button
          type="danger"
          @click="(dialog = true), doGroupAdd()"
          v-hasPermission="['system:group']"
          >添加权组</el-button
        >
      </div>
    </el-col>
  </el-row>

  <el-row class="mainTableBox">
    <el-col :span="24" class="mpadding">
  <el-table
    :data="tableData"
    v-loading="loadingData"
    class="mainTable"
  >
    <el-table-column label="名称" prop="name" />
    <el-table-column label="角色" prop="grouptag" />
    <el-table-column label="说明" prop="summary" />
    <el-table-column label="操作" fixed="right" width="260">
      <template #default="scope">
        <el-link
          type="primary"
          size="small"
          @click="open('system:group:permission', scope.row)"
          v-hasPermission="['system:group:permission']"
          >权限</el-link
        >
        <el-link
          type="primary"
          size="small"
          @click="open('system:group:user', scope.row)"
          v-hasPermission="['system:group:user']"
          >成员</el-link
        >
        <el-link
          type="primary"
          size="small"
          @click="(dialog = true), doGroupEdit(scope.$index, scope.row)"
          v-hasPermission="['system:group']"
          >编辑</el-link
        >

        <el-popconfirm
          confirm-button-type="danger"
          confirm-button-text="确定"
          cancel-button-text="取消"
          icon-color="#626AEF"
          title="您确定要删除吗？"
          @confirm="doGroupDelete(scope.$index, scope.row)"
        >
          <template #reference>
            <el-link
              size="small"
              type="danger"
              v-hasPermission="['system:group']"
              >删除</el-link
            >
          </template>
        </el-popconfirm>
      </template>
    </el-table-column>
  </el-table>
  </el-col>
  </el-row>

  <el-row class="mainTableBottom">
    <el-col :span="8"><div>
        <!-- <el-button
          type="danger"
          >添加权组</el-button> -->
      </div></el-col>
    <el-col :span="16">
      <div style="float: right">
        <el-pagination
          :hide-on-single-page="true"
          v-model:page-size="queryParam.pageSize"
          :page-sizes="[10, 15, 20, 30]"
          :background="true"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="changeChangeSize"
          @current-change="changePage"
        />
      </div>
    </el-col>
  </el-row>

  <el-drawer
    ref="drawerRef"
    v-model="dialog"
    :title="title"
    :close-on-click-modal="false"
    direction="rtl"
    size="45%"
    @close="doGroupClose"
  >
    <div class="common-drawer__content">
      <el-form
        ref="groupFormRef"
        :model="groupForm"
        :rules="rules"
        label-width="120px"
      >
        <el-form-item label="名称" prop="name">
          <el-input
            v-model.trim="groupForm.name"
            placeholder="请输入组名称，如管理员"
          />
        </el-form-item>
        <el-form-item label="角色名称" prop="grouptag">
          <el-input
            v-model.trim="groupForm.grouptag"
            placeholder="请输入角色名称，如admin"
          />
        </el-form-item>

        <el-form-item label="说明" prop="summary">
          <el-input v-model="groupForm.summary" type="textarea" />
        </el-form-item>
      </el-form>
      <div class="common-drawer__footer">
        <el-button @click="doGroupClose">关闭</el-button>
        <el-button type="danger" :loading="loading" @click="doGroupSave">{{
          loading ? "提交中 ..." : "提交"
        }}</el-button>
      </div>
    </div>
  </el-drawer>
</template>
    
  <script setup>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { ElDrawer, ElTable, ElMessage } from "element-plus";
import { listGroup, saveGroup, deleteGroup } from "@/api/group";

const router = useRouter();
let open = (routeName, row) => {
  // console.log("routeName----", routeName, row.groupid);
  // router.push({ name: 'user', params: { username } }) // -> /user/eduardo
  // console.log(router)
  router.push({
    name: routeName,
    params: { id: row.groupid },
    query: { name: row.name },
  });
};

let timer;

let dialog = ref(false);
const loading = ref(false);
const loadingData = ref(true);

const drawerRef = ref(ElDrawer);

const groupFormRef = ref();

const total = ref(0);
const pageSize = ref(15); //每页显示条数

let title = ref("添加权组");

//搜索查询
const queryParam = ref({
  pageNo: 1,
  pageSize: pageSize.value,
  name: "",
});
const resetSearch = () => {
  queryParam.value = {
    pageNo: 1,
    pageSize: pageSize.value,
    name:"",
  };
  getListGroup();
};

const groupForm = ref({
  groupid: null,
  name: "",
  grouptag: "",
  summary: "",
});

const tableData = ref([]);

//onMounted方法
onMounted(() => {
  getListGroup();
});

const doGroupAdd = () => {
  title.value = "新增权组";
  resetForm();
};

const doGroupEdit = (index, obj) => {
  title.value = "编辑权组";
  // groupForm.value = obj;//直接赋值会出问题
  groupForm.value = {
    groupid: obj.groupid,
    name: obj.name,
    grouptag: obj.grouptag,
    summary: obj.summary,
  };
};
const doGroupDelete = (index, obj) => {
  deleteGroup(obj).then((res) => {
    if (res.data.code === 1) {
      getListGroup();
    } else {
      ElMessage.error(res.data.msg);
    }
  });
};

const doGroupClose = () => {
  loading.value = false;
  dialog.value = false;
  clearTimeout(timer);
  groupFormRef.value.resetFields()
};

const resetForm = () => {
  groupForm.value = {
    groupid: null,
    name: "",
    grouptag: "",
    summary: "",
  };
};

const doGroupSave = () => {
  groupFormRef.value.validate((valid) => {
    if (!valid) {
      //ElMessage("请先完善表单数据填写！");
      return;
    }

    saveGroup(groupForm.value).then((res) => {
      loading.value = true;
      timer = setTimeout(() => {
        // 动画关闭需要一定的时间
        setTimeout(() => {
          loading.value = false;
        }, 400);
        if (res.data.code === 1) {
          getListGroup();
          doGroupClose();
        } else {
          ElMessage.error(res.data.msg);
        }
      }, 1000);
    });
  });
};

//关闭用户表单弹出框
// const doDrawerClose = (done) => {
//   if (loading.value) {
//     return;
//   }
//   ElMessageBox.confirm("您确定要提交表单数据吗？", {
//     distinguishCancelAndClose: true,
//     confirmButtonText: "确定提交",
//     cancelButtonText: "取消",
//   })
//     .then(() => {
//       loading.value = true;
//       timer = setTimeout(() => {
//         done();
//         // 动画关闭需要一定的时间
//         setTimeout(() => {
//           loading.value = false;
//         }, 400);
//       }, 1000);
//     })
//     .catch(() => {
//       // catch error
//     });
// };

//分页
const changePage = (current) => {
  queryParam.value.pageNo = current;
  getListGroup();
};
const changeChangeSize = (size) => {
  pageSize.value = size;
  queryParam.value.pageSize = size;
  getListGroup();
};

//组列表API
const getListGroup = () => {
  listGroup(queryParam.value).then((res) => {
    tableData.value = res.data.extend.pages.list;
    total.value = res.data.extend.pages.total;
    queryParam.value.pageSize = pageSize.value;
    loadingData.value = false
  });
};

//表单验证规则
const rules = ref({
  name: [
    {
      required: true,
      message: "请输入名称",
      trigger: "blur",
    },
    {
      min: 2,
      max: 15,
      message: "组名称长度2到15",
      trigger: "blur",
    },
  ],
  grouptag: [
    {
      required: true,
      message: "请输入角色名称",
      trigger: "blur",
    },
    {
      min: 2,
      max: 50,
      message: "角色长度2到15",
      trigger: "blur",
    },
  ],
});
</script>